export const defaultChecks = [
  {
    id: 0,
    status: false,
    text: 'Validación de identidad'
  },
  {
    id: 1,
    status: false,
    text: 'Validación de documentos personales'
  },
  {
    id: 2,
    status: false,
    text: 'Visita Física'
  },
  {
    id: 3,
    status: false,
    text: 'Validación de Referencias'
  }
]

export const defaultContacts = [
    {
      isCheck: true,
      description: 'Correo Electrónico',
      isActive: true,
      key: "C001"
    },
    {
      isCheck: false,
      description: 'SMS en Teléfono Celular',
      isActive: true,
      key: "C002"
    },
    {
      isCheck: false,
      description: 'WhatsApp',
      isActive: false,
      key: "C003"
    }
]

